import { useQuery } from 'react-query';
import { dsoCheckoutService } from 'services';
import { ServerStateKeysEnum } from '../../constants';

export const useRetriveDsoShippingMethods = () => {
  return useQuery(
    [ServerStateKeysEnum.dsoShippingMethods],
    () => {
      return dsoCheckoutService.getShippingMethods();
    },
    {
      staleTime: Infinity,
    }
  );
};
